<template>
  <v-badge color="#5E72E4" left>
    <template v-slot:badge v-if="carShop.length > 0">
      <span>{{carShop.length}}</span>
    </template>
    <router-link tag="span" to="/home/payment" style="margin-left: -10px">
      <v-icon style="cursor: pointer"> shopping_cart </v-icon>
    </router-link>
  </v-badge>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import toastr from "toastr";
export default {
  name: "badgetTop",
  components: {},
  created() {
    this.getShoppingCar();
  },
  data() {
    return {
      proyect_id: process.env.VUE_APP_PROYECT_ID,
    };
  },
  computed: {
    ...mapState,
    // ...mapGetters(["carShop"]),
    ...mapGetters({
      carShop: "shopingCart/getCart",
    }),
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },

    uec() {
      return JSON.parse(localStorage.getItem("e_x_c"));
    },
  },
  methods: {
    getShoppingCar: function () {
      this.$store.dispatch("shopingCart/getCart")
    },
  },
};
</script>